<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="documents_enrollment"
      :loading="loadingTable"
      class="elevation-1 table-striped"
      hide-actions
    >
      <template v-slot:no-data>
        <v-alert :value="true" color="warning" icon="warning">
          {{ $t(`enrollments.no_documents`) }}
        </v-alert>
      </template>
      <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.item.description }}</td>
          <td class="text-xs-center">
            {{ isDocumentRequired(props.item) ? "Si" : "No" }}
          </td>
          <td class="text-xs-center">{{ props.item.ext }}</td>
          <td>
            <v-container pa-0 grid-list-xs>
            <v-layout justify-space-between row v-if="props.item.document_type === 'digital_sign'">
              <v-flex xs6>
                <v-btn
                  block
                  v-if="files[props.item.id] && files[props.item.id][0].vista_status == 'F'"
                  @click="showVistaFile(files[props.item.id][0])"
                  color="success">
                  {{ $t(`enrollments.see_document`) }}
                </v-btn>
                <v-btn
                  block
                  :disabled="veriry_btn_1"
                  :loading="veriry_btn_1"
                  v-else-if="files[props.item.id] && files[props.item.id][0].vista_status == 'P'"
                  @click="continueVistaSign(files[props.item.id][0], props.item)"
                  color="accent">
                  {{ $t(`enrollments.cont_signature`) }}
                </v-btn>
                <v-btn
                  block
                  v-else
                  @click="showDialogDitialSign(props.item)"
                  color="primary">
                  {{ $t(`enrollments.e_signature`) }}
                </v-btn>
              </v-flex>
              <!-- <v-flex xs6 v-if="props.item.signs_number == 2 && (files[props.item.id] && files[props.item.id][0].signs_number == 2)">
                <v-btn
                  block
                  v-if="files[props.item.id] && files[props.item.id][0].status_2 == 0"
                  @click="showFile(files[props.item.id][0].documento_homini_2, true)"
                  color="success">
                  Ver documento
                </v-btn>
                <v-btn
                  block
                  :disabled="veriry_btn_2"
                  :loading="veriry_btn_2"
                  v-else-if="files[props.item.id] && files[props.item.id][0].status_2 == 9"
                  @click="validateSign(files[props.item.id][0].id, 2)"
                  color="accent">
                  Validar Firma
                </v-btn>
                <v-btn
                  block
                  v-else-if="files[props.item.id] && files[props.item.id][0].status == 0"
                  @click="showDialogDitialSign(props.item.id, 2)"
                  color="primary">
                  Firma electrónica 2
                </v-btn>
              </v-flex> -->
            </v-layout>
            <v-layout justify-space-between row v-if="props.item.document_type === 'upload'">
              <v-flex xs12 v-show="files[props.item.id] && files[props.item.id].length > 0">
                <ul>
                  <li v-for="(file) in files[props.item.id]" :key="file.id">
                    <span >{{file.name}}</span> -
                    <span v-show="!(files[props.item.id] && files[props.item.id].length > 0 && files[props.item.id][0].id > 0)">{{file.size}}</span>
                    &nbsp;&nbsp;&nbsp;
                    <span v-show="!(files[props.item.id] && files[props.item.id].length > 0 && files[props.item.id][0].id > 0)">
                      <v-tooltip top>
                        <v-icon
                          small
                          class="mr-2"
                          @click.prevent="$refs[`upload_${props.item.id}`].remove(file)"
                          slot="activator"
                        >
                          delete
                        </v-icon>
                        <span>{{$t('extracurriculares.clothes.delete')}}</span>
                      </v-tooltip>
                    </span>
                    <span v-if="files[props.item.id] && files[props.item.id].length > 0 && files[props.item.id][0].path">
                      <v-tooltip top>
                        <v-icon
                          small
                          class="mr-2"
                          @click.prevent="showFile(files[props.item.id][0].path, false)"
                          slot="activator"
                        >
                          remove_red_eye
                        </v-icon>
                        <span>Ver archivo</span>
                      </v-tooltip>
                    </span>
                    <span v-if="files[props.item.id] && files[props.item.id].length > 0 && files[props.item.id][0].id > 0">
                      <v-tooltip top>
                        <v-icon
                          small
                          class="mr-2"
                          @click.prevent="deleteFile(files[props.item.id][0].id)"
                          slot="activator"
                        >
                          delete
                        </v-icon>
                        <span>{{$t('extracurriculares.clothes.delete')}}</span>
                      </v-tooltip>
                    </span>

                  </li>
                </ul>
              </v-flex>
              <v-flex xs6 v-show="!(files[props.item.id] && files[props.item.id].length > 0)">
                <file-upload
                  v-show="!(files[props.item.id] && files[props.item.id].length > 0 && files[props.item.id][0].id > 0)"
                  class="v-btn theme--dark primary v-btn--block"
                  :extensions="props.item.ext"
                  :multiple="false"
                  :size="1024 * 1024 * 10"
                  v-model="files[props.item.id]"
                  @input-filter="inputFilter"
                  @input-file="inputFile"
                  :input-id="`file_${props.item.id}`"
                  :ref="`upload_${props.item.id}`">
                  {{ $t(`enrollments.select_files`) }}
                </file-upload>
              </v-flex>
            </v-layout>
            <v-layout justify-space-between row v-if="props.item.document_type === 'template'">
              <v-flex xs12 v-show="files[props.item.id] && files[props.item.id].length > 0">
                <ul>
                  <li v-for="(file) in files[props.item.id]" :key="file.id">
                    <span >{{file.name}}</span> -
                    <span v-show="!(files[props.item.id] && files[props.item.id].length > 0 && files[props.item.id][0].id > 0)">{{file.size}}</span>
                    &nbsp;&nbsp;&nbsp;
                    <span v-if="!(files[props.item.id] && files[props.item.id].length > 0 && files[props.item.id][0].id > 0)">
                      <v-tooltip top>
                        <v-icon
                          small
                          class="mr-2"
                          @click.prevent="$refs[`upload_${props.item.id}`].remove(file)"
                          slot="activator"
                        >
                          delete
                        </v-icon>
                        <span>{{$t('extracurriculares.clothes.delete')}}</span>
                      </v-tooltip>
                    </span>
                    <span v-if="files[props.item.id] && files[props.item.id].length > 0 && files[props.item.id][0].path">
                      <v-tooltip top>
                        <v-icon
                          small
                          class="mr-2"
                          @click.prevent="showFile(files[props.item.id][0].path, false)"
                          slot="activator"
                        >
                          remove_red_eye
                        </v-icon>
                        <span>{{ $t(`enrollments.see_file`) }}</span>
                      </v-tooltip>
                    </span>
                    <span v-show="files[props.item.id] && files[props.item.id].length > 0 && files[props.item.id][0].id > 0">
                      <v-tooltip top>
                        <v-icon
                          small
                          class="mr-2"
                          @click.prevent="deleteFile(files[props.item.id][0].id)"
                          slot="activator"
                        >
                          delete
                        </v-icon>
                        <span>{{$t('extracurriculares.clothes.delete')}}</span>
                      </v-tooltip>
                    </span>

                  </li>
                </ul>
              </v-flex>
              <v-flex xs6 v-show="!(files[props.item.id] && files[props.item.id].length > 0)">
                <file-upload
                  v-show="!(files[props.item.id] && files[props.item.id].length > 0 && files[props.item.id][0].id > 0)"
                  class="v-btn theme--dark primary v-btn--block"
                  :extensions="props.item.ext"
                  :multiple="false"
                  :size="1024 * 1024 * 10"
                  v-model="files[props.item.id]"
                  @input-filter="inputFilter"
                  @input-file="inputFile"
                  :input-id="`file_${props.item.id}`"
                  :ref="`upload_${props.item.id}`">
                  {{ $t(`enrollments.select_files`) }}
                </file-upload>
              </v-flex>
              <v-flex xs6 v-show="!(files[props.item.id] && files[props.item.id].length > 0)">
                <a
                  class="v-btn theme--light accent v-btn--block"
                  :href="props.item.path"
                  download
                  target="_blank"
                >
                {{$t('enrollments.down_template')}}</a>
              </v-flex>
            </v-layout>
            <v-layout justify-space-between row v-if="props.item.document_type === 'read_only'">
              <v-flex xs6>
                <a
                  class="v-btn theme--light success v-btn--block"
                  :href="props.item.path"
                  target="_blank"
                >
                {{ $t(`enrollments.see_document`) }}</a>
              </v-flex>
            </v-layout>
            </v-container>
          </td>
      </template>
    </v-data-table>
    <v-layout row justify-center mt-3>
      <v-btn flat @click="goToPrevStep">{{ $t(`enrollments.back`) }}</v-btn>
      <v-btn
          :disabled="!canContinue || loadingButton"
          color="primary"
          @click="goToNextStep"
          :loading="loadingButton"
      >
      {{ $t(`enrollments.next`) }}
      </v-btn>
    </v-layout>
    <v-dialog
      v-model="dialogDigitalSign"
      fullscreen>
      <digital-sign-comp
        v-on:closeDialog="closeSignDialog"
        :studentId="student.student_number || ''"
        :documentId="documentSignId"
        :action="vista_action"
        :processId="document_process_id"
        :recordId="vista_record_id"
      ></digital-sign-comp>
    </v-dialog>
    <v-dialog v-model="showFileDialog" max-width="500px">
        <v-card>
            <v-card-title>
                <span class="headline">{{ $t(`enrollments.doc_uploaded`) }}</span>
            </v-card-title>

            <v-card-text>
                <object :data="path_file" width="460px" height="500px"></object>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="showFileDialog = false">{{ $t(`enrollments.cancel`) }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import axios from 'axios'
  import FileUpload from 'vue-upload-component'
  import Form from 'vform'
  import DigitalSignComponent from './digital_sign'
  export default {
    name: 'enrollment-step-2',
    components: {
      FileUpload,
      'digital-sign-comp': DigitalSignComponent,
    },
    data() {
      return {
        headers: [
            { text: this.$t(`enrollments.header.document`), align: 'center', sortable: false},
            { text: this.$t(`enrollments.header.required`), align: 'center', sortable: false},
            { text: this.$t(`enrollments.header.extension`), align: 'center', sortable: false },
            { text: this.$t(`enrollments.header.actions`), align: 'center', sortable: false }
        ],
        documents_enrollment: [],
        documents_enrollment_students: [],
        loadingTable: false,
        loadingButton: false,
        files: {},
        dialogDigitalSign: false,
        formSign: new Form({
          names: '',
          lastname: '',
          identification_number: '',
          phone: '',
          email: '',
          address: '',
          enrollment_id: '',
          student_id: '',
          id_digital_document: '',
          step_2: true
        }),
        showFileDialog: false,
        path_file: '',
        veriry_btn_1: false,
        veriry_btn_2: false,
        current_sign_document: '',
        making_call: false,
        documentSignId: 0,
        document_process_id: 0,
        vista_action: '',
        vista_record_id: ''
      }
    },
    created () {
      this.loadingTable = true
      this.init();
    },
    computed: {
      ...mapGetters({
        enrollment_id: 'currentEnrollmentId',
        enrollment_status: 'currentEnrollment',
        enrollment_status_id: 'currentEnrollmentStatusId',
        student: 'currentEnrollmentStudent',
        isExtempEnrollment: 'isExtempEnrollment',
      }),
      canContinue() {
        let canContinue = this.documents_enrollment.length > 0
        const student_next_grade = this.student.next_grade;
        this.documents_enrollment.forEach(document => {
          if (this.isDocumentRequired(document)) {
            if (!this.files[document.id] || this.files[document.id].length === 0) {
              canContinue = false
            }
            if (document.document_type === 'digital_sign' && this.files[document.id]) {
              if (this.files[document.id].length > 0) {
                if (this.files[document.id][0][`vista_status`] != 'F') {
                  canContinue = false
                }
              }
            }
          }
        })

        return canContinue
      }
    },
    watch: {
      enrollment_status(newValue, oldValue) {
        this.files = []
        if (newValue.documents) {
          this.files = {}
          newValue.documents.forEach(document => {
            this.files[document.enrollment_document_id] = [
              {
                digital_sign: document.codigo_homini ? true : false, status: document.estado_firma_homini, id: document.id, name: document.name_file, path: document.path_file,
                digital_sign_2: document.codigo_homini__2 ? true : false, status_2: document.estado_firma_homini_2,
                documento_homini: document.documento_homini, documento_homini_2: document.documento_homini_2,
                signs_number: document.document ?
                ((this.student && this.student.father_lives && this.student.father_lives.toLowerCase() == 'no') || (this.student && this.student.mother_lives && this.student.mother_lives.toLowerCase() == 'no'))
                ? 1 : document.document.signs_number
                : 0  ,
                vista_sign: document[`360_document_status`] ? true : false,
                vista_status: document['360_document_status'],
                vista_id: document['360_document_id'],
              }
            ]
          })
        }
      },
      dialogDigitalSign(newValue, oldValue) {
        if (oldValue && !newValue) {
          this.documentSignId = ''
          this.vista_action = ''
          this.document_process_id = ''
          this.vista_record_id = ''
        }
      }
    },
    methods: {
      goToPrevStep() {
        this.$emit('goToPrevStep', 1)
      },
      async goToNextStep() {
        // if (this.enrollment_status.current_step > 2) {
        //   this.$emit('goToNextStep', 3)
        //   return
        // }
        this.loadingTable = true;
        this.loadingButton = true;
        let formData = new FormData();
        let fileData
        let total_files = 0;
        Object.keys(this.files).forEach(file => {
          if (this.files[file] && !this.files[file][0].digital_sign) {
            if (this.$refs[`upload_${file}`]) {
              fileData = this.$refs[`upload_${file}`].get(this.files[file][0].id)
              if (!fileData.path){
                console.log("appending file:", fileData.file);
                formData.append(`file_${file}`, fileData.file)
                total_files++;
              }
            }
          }
        })
        if (total_files === 0){
          this.loadingTable = false;
          this.loadingButton = false;
          this.$emit('goToNextStep', 3)
          return;
        }
        formData.append('student_id', this.student.id)
        formData.append('enrollment_id', this.enrollment_id)
        formData.append('enrollment_status_id', this.enrollment_status_id)
        formData.append('total_documents', this.documents_enrollment.length);
        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }

        axios.post('/api/enrollment/start/saveDocumentsStudent', formData, config)
          .then(response => {
            const { data } = response;
            if (data.response) {
                this.$store.dispatch('responseMessage', {
                    type: 'success',
                    text: data.message,
                    title: this.$t('enrollments.start.upload-files-complete-title'),
                    modal: false
                })
                const payload = {
                  enrollment_id: this.enrollment_id,
                  student_id: this.student.id,
                  current_step: 3,
                }
                this.$store.dispatch('fetchEnrollmentStatus', payload)
                this.loadingTable = false;
                this.loadingButton = false;
                this.$emit('goToNextStep', 3)
            } else {
                const payload = {
                  enrollment_id: this.enrollment_id,
                  student_id: this.student.id,
                }
                this.$store.dispatch('fetchEnrollmentStatus', payload)
                this.loadingTable = false;
                this.loadingButton = false;
                this.$store.dispatch('responseMessage', {
                    type: 'warning',
                    text: data.message,
                    title: this.$t('enrollments.start.upload-files-incomplete-title'),
                    modal: true
                })
            }
          })
          .catch(error => {
            this.loadingButton = false;
          })

      },
      init() {
        axios.get(`/api/enrollment/start/getEnrollmentDocuments/${this.enrollment_id}`)
          .then(resp => {
            if (resp.status === 200) {
              this.documents_enrollment = resp.data
            }
            this.loadingTable = false;
          })
          .catch(error => {
            this.loadingTable = false
            console.log(error)
          })

        axios.get(`/api/enrollment/start/getEnrollmentDocumentsStudents/${this.enrollment_id}`)
          .then(resp => {
            if (resp.status === 200) {
              this.documents_enrollment_students = resp.data
            }
            this.loadingTable = false;
          })
          .catch(error => {
            this.loadingTable = false
            console.log(error)
          })


          if (this.enrollment_status.documents) {
            this.files = {}
            this.enrollment_status.documents.forEach(document => {
              this.files[document.enrollment_document_id] = [
                {
                  digital_sign: document.codigo_homini ? true : false,
                  status: document.estado_firma_homini,
                  id: document.id,
                  name: document.name_file,
                  path: document.path_file,
                  digital_sign_2: document.codigo_homini__2 ? true : false,
                  status_2: document.estado_firma_homini_2,
                  documento_homini: document.documento_homini,
                  documento_homini_2: document.documento_homini_2,
                  signs_number: document.document ?
                    ((this.student && this.student.father_lives && this.student.father_lives.toLowerCase() == 'no') || (this.student && this.student.mother_lives && this.student.mother_lives.toLowerCase() == 'no'))
                    ? 1 : document.document.signs_number
                    : 0,
                  vista_sign: document[`360_document_status`] ? true : false,
                  vista_status: document['360_document_status'],
                  vista_id: document['360_document_id'],
                }
              ]
            })
          }
      },
      inputFilter(newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
          if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
            return prevent()
          }

          if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
            return prevent()
          }
        }
      },
      inputFile(newFile, oldFile) {
        if (newFile && !oldFile) {
          // add
          console.log('add', newFile)
        }
        if (newFile && oldFile) {
          // update
          console.log('update', newFile)
        }
        if (!newFile && oldFile) {
          // remove
          console.log('remove', oldFile)
        }
      },
      isDocumentRequired(document){
        const required_next_step = JSON.parse(document.required_next_step === null ? "[]" : document.required_next_step)
        let isRequired = false;
        if (required_next_step.includes(this.student.next_grade) || required_next_step[0] === 'ALL' || this.isExtempEnrollment) {
          isRequired = true
        }

        if (this.documents_enrollment_students.length > 0 && !isRequired) {
          const studentsHasDocument = this.documents_enrollment_students.filter((enrollmentDocument) =>
            enrollmentDocument.enrollment_document_id == document.id && enrollmentDocument.student_id == this.student.id)
          isRequired = studentsHasDocument.length > 0;
        }

        return isRequired
      },
      showDialogDitialSign(document) {
        const payload = {
          enrollment_status_id: this.enrollment_status_id,
          enrollment_document_id: document.id,
        }
        this.vista_action = 'CREATE'
        axios.post('/api/enrollment/start/360_sign', payload)
          .then(resp => {
            if (resp.status === 200) {
              this.document_process_id = resp.data.id
              this.documentSignId = document.digital_id_documet
              this.dialogDigitalSign = true
            }
          })
          .catch(err => console.log(err))
      },
      showVistaFile(file) {
        this.vista_action = 'SHOW'
        this.vista_record_id = file.vista_id
        this.dialogDigitalSign = true
      },
      continueVistaSign(file, document) {
        if (!file.vista_id && file.vista_id > 0) {
          this.vista_action = 'UPDATE'
        } else {
          this.vista_action = 'CREATE'
        }
        this.document_process_id = file.id
        this.documentSignId = document.digital_id_documet
        this.vista_record_id = file.vista_id
        this.dialogDigitalSign = true
      },
      closeSignDialog() {
        const payload = {
          enrollment_id: this.enrollment_id,
          student_id: this.student.id,
        }
        this.$store.dispatch('fetchEnrollmentStatus', payload)
        this.dialogDigitalSign = false
      },
      startDigitalSign() {
        this.$validator.validateAll('sign_form').then(valid => {
          if (valid) {
            this.making_call = true;
            axios.post('/api/enrollment/start/startDigitalSign', this.formSign)
              .then(resp => {
                if (resp.status === 200) {
                  if (resp.data.signed_document) {
                    this.dialogDigitalSign = false;
                    const payload = {
                      enrollment_id: this.enrollment_id,
                      student_id: this.student.id,
                    }
                    this.$store.dispatch('fetchEnrollmentStatus', payload)
                    this.formSign.clear();
                    this.formSign.reset();
                    this.$store.dispatch('responseMessage', {
                        type: 'success',
                        title: this.$t('enrollments.sign-form.stored-ok-title'),
                        text: this.$t('enrollments.sign-form.stored-ok-text') + resp.data.codigo_homini,
                        modal: true
                    })
                  }
                }
                this.making_call = false;
              })
              .catch(error => {
                this.making_call = false;
              })
          }
        })
      },

      showFile(path, is_digital) {
        this.showFileDialog = true;
        if (!is_digital) {
          this.path_file = path
          return
        }

        this.path_file = `data:application/pdf;base64,${path}`
      },
      deleteFile(id) {
        axios.delete(`/api/enrollment/start/file/${id}`)
          .then(resp => {
            if (resp.status === 200) {
              const payload = {
                enrollment_id: this.enrollment_id,
                student_id: this.student.id,
              }
              this.$store.dispatch('fetchEnrollmentStatus', payload)
            }
          })
          .catch(error => console.log(error))
      },
      async validateSign(id, number) {
        if (number == 1) {
          this.veriry_btn_1 = true
        } else {
          this.veriry_btn_2 = true;
        }
        const result = await axios.get(`/api/enrollment/start/verifyDigitalSign/${id}/${this.enrollment_id}/${number}`);
        const payload = {
          enrollment_id: this.enrollment_id,
          student_id: this.student.id,
        }
        this.$store.dispatch('fetchEnrollmentStatus', payload)

        this.veriry_btn_1 = false
        this.veriry_btn_2 = false
        if (!result.data.response) {
          this.$store.dispatch('responseMessage', {
            type: 'warning',
            text: result.data.message,
            title: 'La firma no se ha completado correctamente',
            modal: true
          })
        } else {
          if (result.data.status != 0) {
            this.$store.dispatch('responseMessage', {
              type: 'warning',
              text: result.data.message,
              title: 'La firma no se ha completado correctamente',
              modal: false
            })
          } else {
            this.$store.dispatch('responseMessage', {
              type: 'success',
              text: 'El documento fue firmado correctamente',
              title: 'Firma completada',
              modal: false
            })
          }
        }

      }
    },

  }
</script>

<style>
.file-uploads {
  display: inline-flex !important;
}
.v-btn {
  line-height: 1;
  text-align: center;
}
.padding-0 {
  padding: 0 !important;
}
.table-striped tbody tr:nth-of-type(odd) {
   background-color: rgba(0, 0, 0, .05);
 }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/enrollment/enrollment_step2.vue